import Player from '@vimeo/player';

export default class Video {
  video;
  code;
  videoPlayerNode;
  vimeoPlayer;
  
  constructor(video) {
    this.video = video;
    this.video.style.height = this.video.clientWidth * 9 / 16 + 'px';
    this.code = this.video.getAttribute('data-code');
    this.videoPlayerNode = document.createElement('div');
    this.video.appendChild(this.videoPlayerNode);
    this.loadVideo();
  }

  loadVideo() {
    let options = {
      id: this.code,
      width: this.videoPlayerNode.clientWidth,
      height: this.videoPlayerNode.clientWidth * 9 / 16,
      controls: true,
      muted: false,
      background: true,
      autoplay: false,
      byline: false,
      title: false,
    };
    debugger;

    this.vimeoPlayer = new Player(this.videoPlayerNode, options);
  }


}


// WEBPACK FOOTER //
// ./ui/assets/js/Video/Video.js